export default __webpack_public_path__ + "locales/ko-KR/Files.json?hash=8f2daa59cbbdd6a490fc8d7928072d26";